module.exports = __webpack_public_path__ + "static/media/bet_1.17c49280.mp3";